<!--KRK大家庭模块-->
<template>
  <div class="family-page">
    <div class="header clearfix">
      <div class="header-left">
        <div class="hr"></div>
        <h2>KRK大家庭</h2>
        <h3>Since 1961</h3>
      </div>
      <div class="header-right">Kids 'R' Kids Family</div>
    </div>
    <Map></Map>
    <div class="form-box">
      <h2>合作伙伴登记表</h2>
      <h3>欢迎加入KRK大家庭</h3>
      <div class="rows semi-rows">
        <p class="label check">姓名</p>
        <input type="text" class="editInp" v-model="formData.name" @blur="blurName($event)">
      </div>
      <div class="rows semi-rows w480 mgL66">
        <p class="label check">手机</p>
        <input type="text" class="editInp" v-model="formData.phone" @blur="blurPhone($event)">
      </div>
      <div class="rows semi-rows">
        <p class="label check">微信</p>
        <input type="text" class="editInp" v-model="formData.weixin">
      </div>
      <div class="rows semi-rows w480 mgL66">
        <p class="label check">邮箱</p>
        <input type="text" class="editInp" v-model="formData.email" @blur="blurEmail($event)">
      </div>
      <div class="rows">
        <p class="label check">公司名称及地址</p>
        <div class="rows semi-rows w319 mgL0">
          <input maxLength="30" type="text" class="editInp" v-model="formData.company">
        </div>
        <div class="rows semi-rows w662 mgL24">
          <input maxLength="30" type="text" class="editInp" v-model="formData.companyAddr">
        </div>
      </div>
      <div class="rows">
        <p class="label check">城市及区域</p>
        <div class="editDiv w319">
          <select v-model="prov">
            <option v-for="(option, index) in cityDatas" :value="option.name" :key="index">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="editDiv w319">
          <select v-model="city">
            <option v-for="(option, index) in cityArr" :value="option.name" :key="index">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="editDiv w319">
          <select v-model="district">
            <option v-for="(option, index) in districtArr" :value="option.name" :key="index">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="rows">
        <p class="label check">您关注的合作项目问题</p>
        <textarea rows="4" maxlength="200" class="textarea" v-model="formData.note" @blur="blurQuestion($event)"></textarea>
      </div>
      <p class="submit-btn" @click.stop="submitForm();">提交表格</p>
      <P class="submit_error" v-show="showError">抱歉，您填入的信息有误</p>
    </div>
  </div>
</template>

<script>
  import Map from '@/pages/kindergarten/map' //地图模块
  import axios from 'axios'
  import cityDatas from '../../../static/mock/city.js'
  export default {    
    data() {
      return {
        showCity: false,
        showZone: false,
        showError: false,
        formData: {
          name: '',
          phone: '',
          weixin: '',
          email: '',
          company: '',
          companyAddr: '',
          city: '',
          zone: '',
          note: ''
        },
        cityDatas: cityDatas,
        prov: '北京',
        city: '北京',
        district: '东城区',
        cityArr: [],
        districtArr: [],
        // baseUrl: 'http://47.93.230.5:9000',// 开发环境
        // baseUrl: 'http://47.94.143.244:9000',// 测试环境
        baseUrl:'http://api.kidsrkidschina.com',// 线上
      }
    },
    mounted() {
      this.globalClick(this.selectRemove);      
    },
    components: {
      Map         
    },
    beforeMount: function () {
      this.updateCity();
      this.updateDistrict();
    },
    methods: {
      updateCity: function () {
        for (var i in this.cityDatas) {
          var obj = this.cityDatas[i];
          if (obj.name == this.prov) {
            this.cityArr = obj.sub;
            break;
          }
        }
        this.city = this.cityArr[1].name;
      },
      updateDistrict: function () {
        for (var i in this.cityArr) {
          var obj = this.cityArr[i];
          if (obj.name == this.city) {
            this.districtArr = obj.sub;
            break;
          }
        }
        if(this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
          this.district = this.districtArr[1].name;
        } else {
          this.district = '';
        }
      },
      selectRemove() {
        this.showCity = false;
        this.showZone = false;
      },
      selectCity() {
        this.showCity = !this.showCity;
      },
      selectZone() {
        this.showZone = !this.showZone;
      },
      activeCity(item) {
        this.cityData.forEach((k) => {
          k.active = false
        })
        item.active = true;
        this.formData.city = item.value;
        this.showCity = false;
      },
      activeZone() {
        this.cityData.forEach((k) => {
          k.active = false
        })
        item.active = true;
        this.formData.zone = item.value;
        this.showZone = false;
      },
      blurName(e) {       
        let nameReg = /^[a-zA-Z\u4e00-\u9fa5]+$/g,
          tar = e.target;
        if(!nameReg.test(this.formData.name)) {
          tar.className = 'editInp error';
          this.showError = true;
          return false;
        } else {
          tar.className = 'editInp';
          this.showError = false;
          return true;
        }
      },
      blurQuestion(e) {
        let nameReg = /^[a-zA-Z\u4e00-\u9fa5]+$/g,
          tar = e.target;
        if(!nameReg.test(this.formData.note)) {
          tar.className = 'editInp error text-editInp';
          this.showError = true;
          return false;
        } else {
          tar.className = 'editInp text-editInp';
          this.showError = false;
          return true;
        }
      },
      blurPhone(e) {        
        let phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/,
          tar = e.target;
        if(!phoneReg.test(this.formData.phone)) {
          tar.className = 'editInp error';
          this.showError = true;
          return false;
        } else {
          tar.className = 'editInp';
          this.showError = false;
          return true;
        }
      },
      blurEmail(e) {
        let emailReg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"),
          tar = e.target;
        if(!emailReg.test(this.formData.email)) {
          tar.className = 'editInp error';
          this.showError = true;
          return false;
        } else {
          tar.className = 'editInp';
          this.showError = false;
          return true;
        }
      },
      submitForm() {
        let temp = this.formData;
        if(!temp.name || !temp.phone || !temp.weixin || !temp.email || !temp.company || !temp.companyAddr || !this.prov || !this.city || !this.district || !temp.note) {
          alert('请填写完整');
          return;
        }
        
        let params = {
          name: temp.name,  //姓名
          photo: temp.phone, //手机
          wechat: temp.weixin,  //微信
          email: temp.email, //邮箱
          companyName: temp.company, //公司名称
          companyAddress: temp.companyAddr, //公司地址
          address: this.prov + this.city + this.district, //区域及地址
          question: temp.note //问题
        };
        axios.defaults.baseURL = this.baseUrl;
        axios
          .post("/webSite/partnerRegister", JSON.stringify(params),{
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            alert('提交成功');
          })
          .catch(err => {
            alert('请求失败，请稍后再试')
          });
      }
    },
    watch: {
      prov: function () {
        this.updateCity();
        this.updateDistrict();
      },
      city: function () {
        this.updateDistrict();
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  @import "@/assets/css/variables.scss";
  .family-page {
    width: 1200px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .header {
      width: 1200px;
      height: 155px;
      overflow: hidden;
      margin-top: 133px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          height: 96px;
          font-size: 48px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 96px;
        }
        h3 {
          width: 142px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: left;
        width:683px;
        height:73px;
        margin-left: 250px;
        font-size: 70px;
        font-family: imesNewRomanPS-ItalicMT;
        font-style: italic;
        line-height: 122px;
        text-align: left;
        color: rgba(204, 204, 204, 1);
      }
    }
    .map {
      width: 888px;
      height: 746px;
      margin: 80px auto 95px;
    }
    .form-box {
      display: none;
      width: 1200px;
      margin: 0 auto 195px auto;
      height: 899px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 10px 0px rgba(202, 202, 202, 0.5);
      h2 {
        padding-top: 53px;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
        text-align: center;
      }
      h3 {
        width: 100%;
        height: 95px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(153, 153, 153, 1);
        line-height: 36px;
        text-align: center;
      }
      .rows {
        clear: both;
        margin-bottom: 30px;
        margin-left: 75px;
        font-family: PingFangSC-Regular;
        p.label {
          position: relative;
          padding-left: 10px;
          height: 20px;
          line-height: 20px;
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
        }
        p.label.check::before {
          position: absolute;
          content: '';
          top: 5px;
          left: 0;
          width: 5px;
          height: 5px;
          background: #AE954F;
          border-radius: 50%;
        }
        .editInp {
          width: 100%;
          height: 40px;
          padding: 10px;
          font-size: 14px;
          color: #333;
          border: 1px solid $color-primary;
          box-sizing: border-box;
        }
        .editInp.error {
          border: 1px solid #ED3E3E;
        }
        .editInp.text-editInp {
          width: 1005px;
          height: 122px;
        }
        .editDiv {
          float: left;
          width: 100%;
          height: 40px;
          padding: 10px;
          font-size: 14px;
          color: #333;
          border: 1px solid #003478;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          margin-bottom: 30px;
          margin-right: 20px;
          a {
            float: right;
            margin-right: 2px;
            display: block;
            width: 8px;
            height: 8px;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            color: #003478;
            border-right: 1px solid #003478;
            border-bottom: 1px solid #003478;
            cursor: pointer;
          }
        }
        .radio-box {
          overflow: hidden;
          margin: 20px 10px;
          li.radio-item {
            float: left;
            margin-right: 50px;
            i {
              position: relative;
              float: left;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
              border: 1px solid $color-primary;
              cursor: pointer;
            }
            span {
              float: left;
              line-height: 20px;
            }
          }
          li.radio-item.active {
            i::before {
              content: '';
              position: absolute;
              left: 6px;
              top: 6px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: $color-primary;
            }
          }
        }
        .channel.radio-box {
          li.radio-item {
            width: 220px;
            margin-bottom: 15px;
          }
        }
        .textarea {
          width: 1005px;
          border: 1px solid $color-primary;
          font-size: 14px;
          color: #333;
          line-height: 25px;
          padding: 10px;
          box-sizing: border-box;
        }
      }
      .rows.semi-rows {
        clear: none;
        float: left;
        width: 460px;
        margin-left: 75px;
      }
      .rows.semi-rows.w480 {
        width: 480px;
      }
      .rows.rows.semi-rows.mgL66 {
        margin-left: 66px;
      }
      .rows.semi-rows.w319,
      .rows .editDiv.w319 {
        width: 319px;
        position: relative;
        border: 0;
        select{
          position: absolute;
          top: 0;
          left: 0;
          width: 319px;
          height: 40px;         
          margin: 0;
          padding: 0;
          border: 0;
          font-size: 14px;
            color: #333;
            border: 1px solid #003478;
            background: #fff;
            option{
            position: absolute;           
            top: 0px;
            left: 0px;
          } 
        }       
      }
      .rows.rows.semi-rows.w662,
      .rows .editDiv.w662 {
        width: 662px;
      }
      .rows.rows.semi-rows.mgL24,
      .rows .editDiv.mgL24 {
        margin-left: 24px;
        position: relative;
        border: 0;
        select{
          position: absolute;
          top: 0;
          left: 0;
          width: 662px;
          height: 40px;         
          margin: 0;
          padding: 0;
          border: 0;
          font-size: 14px;
              color: #333;
              border: 1px solid #003478;
              background: #fff;
              
        }     
      }
      .rows.rows.semi-rows.mgL0 {
        margin-left: 0px;
      }
      .date.rows {
        position: relative;
        .editInp {
          padding-left: 40px;
        }
        i.icon {
          position: absolute;
          top: 40px;
          left: 10px;
          display: block;
          width: 20px;
          height: 20px;
          background: url('../../assets/image/signup_icon_date.png') no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      .submit-btn {
        width: 300px;
        height: 50px;
        line-height: 50px;
        font-size: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        border-radius: 2px;
        margin: 0 auto;
        font-family: PingFang;
        background: rgba(174, 149, 79, 1);
        cursor: pointer;
      }
      .submit_error {
        width: 100%;
        height: 15px;
        padding-top: 17px;
        font-size: 14px;
        font-family: PingFang;
        color: rgba(237, 62, 62, 1);
        text-align: center;
      }
    }
  }
  @media (max-width: 767px) {
    .family-page {
      width: 100%;
      .header {
        width: 100%;
        height: 100px;
        margin-top: 35px;
        .header-left {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.1%;
          .hr {
            width: 56px;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
          }
          h3 {
            width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
          }
        }
        .header-right {
          display: none;
        }
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/pages/kindergarten/family.vue